import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../services/global.service';
import { RouterPathService } from './router-path.service';
import { TranslateService } from './translate-service';
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../../environments/environment";

@Injectable({
    providedIn: 'root'
})

export class GlobalVariableService {

    constructor(public globalService: GlobalService,
        private routerPath: RouterPathService,
        private httpClient: HttpClient,
        public translate: TranslateService,
        private router: Router) { }

    //init function for userData and translate

    public loadLngData(lng: any) {
        const qParam = {
            cmd: this.dataInit,
            lng: lng
        }
        return () => this.httpClient.get(environment.apiUrl, { params: this.globalService.generateParams(qParam) })
            .toPromise()
            .then((data: any) => {
                try {
                    if (data.ok.data) {
                        this.translate.lngData = data.ok.data.translation;
                        this.sCustomerID = data.ok.data.userID;
                        this.bLoggedIn = true;
                        this.sLanguage = lng;
                        if (data.ok.data.userID) {
                            this.router.navigate([this.routerPath.manageProjectPath]);
                        } else {
                            if (window.location.origin.includes("localhost")) {
                                this.router.navigate([this.routerPath.loginString]);
                            } else {
                                window.location.href = this.loginSol50Url;
                            }
                        }
                    }
                } catch { }
            })
    }

    public sProjectName: String = "SOLDraft";
    public sCopyright: String = "© 2024 SEN GmbH";
    public shopURL: string = 'https://soldraft.com/';
    public iVersion: number = 0x00030603;
    public selectedProject: any;
    public selectedProjectId: number;
    public miscellaneousShareObject: any = {};
    public defaultMapZoom = 5.2;
    public defaultLat = 52.5200;
    public defaultLon = 13.4050;
    public createProject = 'newProject';
    public editProject = 'editProject';
    public savePlan = 'savePlan';
    public targetPath = '';
    public nameCollision = 'NAME_COLLISION';
    public metadataChange = 'METADATA_CHANGE';
    public skipCodeArray: string[] = [this.nameCollision, this.metadataChange];
    public phoneNumberValidator = '^[^a-zA-Z_]*$';
    public allowedImageType = ['jpeg', 'png', 'jpg'];
    public enString: string = 'en';
    public deString: string = 'de';
    public sLanguage: String = this.deString;
    public sURLFlexRequest: String = "";
    public sSessionID: String = "";
    public sCustomerID: String = '';
    public bLoggedIn: Boolean = false;
    public sLoginID: String;
    public bSENLogin: Boolean = false;
    public bNoShopLogin: Boolean = false;
    public bTermsCheck: Boolean = false;
    public sAutoUsername: String = "";
    public sAutoPassword: String = "";
    public static aHProfiles: string[] = ["hprofile_l", "hprofile_xxl"];
    public loginSol50Url = `${window.location.origin}/${this.sLanguage}/home/?cmd=login&ref=${encodeURIComponent(window.location.pathname)}`;

    // form max and min char

    public maxStringLength: number = 64;
    public minStringLength: number = 2;
    public PANEL_SIZE_MIN: number = 750;
    public PANEL_SIZE_MAX: number = 2300;
    public PANEL_THICK_MIN: number = 10;
    public PANEL_THICK_MAX: number = 50;

    public formatVersion(iVersion: number): String {
        let sRet: String;
        sRet = ((iVersion & 0x00ff0000) >> 16).toString();
        sRet += "." + ((iVersion & 0x0000ff00) >> 8).toString();
        sRet += "." + (iVersion & 0x000000ff).toString();
        return sRet;
    }



    //api path vars

    //init
    public dataInit = 'Init';
    public switchLng = 'LanguageChange';
    public login = 'Login';

    //project
    public projectBrowse = 'ProjectBrowse';
    public projectGet = 'ProjectGet';
    public projectSave = 'ProjectSave';
    public projectCopy = 'ProjectCopy';
    public projectRemove = 'ProjectRemove';

    //roofplan
    public RoofPlanSave = 'RoofPlanSave';
    public RoofPlanGet = 'RoofPlanGet';
    public RoofPlanRemove = 'RoofPlanRemove';
    public RoofPlanCopy = 'RoofPlanCopy';
    public RoofPlanSearch = 'RoofPlanSearch';
    public ProjectRoofPlanImport = 'ProjectRoofPlanImport';
    public RoofPlanItemList = 'RoofPlanItemList';

    //items
    public ItemDescription = 'ItemDescription';
    public HangerBoltGet = 'HangerBoltGet';
    public ItemListGet = 'ItemListGet';

    //panels
    public PanelManufacturerGetList = 'PanelManufacturerGetList';
    public PanelNameGetList = 'PanelGetList';
    public PanelGet = 'PanelGet';
    public CustomPanelGetList = 'CustomPanelGetList';
    public PanelSave = 'PanelSave';
    public PanelRemove = 'PanelRemove';

    //inverter
    public InverterGetAll = 'InverterGetAll';
    public InverterPlanGet = 'InverterPlanGet';
    public InverterPlanSave = 'InverterPlanSave';
    public InverterPlanACDCGet = 'InverterPlanACDCGet';

    //doc address
    public DocAddressSave = 'DocAddressSave';
    public DocAddressGetAll = 'DocAddressGetAll';
    public DocAddressRemove = 'DocAddressRemove';

    //pdf
    public ProjectDocPrint = 'ProjectDocPrint';
    public ItemListPrint = 'ItemListPrint';
    public ItemListToCart = 'ItemListToCart';

    //country
    public CountryGetAll = 'CountryGetAll';

    //settings
    public SettingsGet = 'SettingsGet';
    public SettingsSave = 'SettingsSave';

    //statics
    public StaticsGet = 'StaticsGet';

    //HProfile

    public HProfileGetAll = 'HProfileGetAll';
}
